<template>
    <v-col>
        <h5>
            {{assigned_label}}
            <v-chip v-if="required" class="ma-2" x-small outlined color="primary">{{$t("form.mandatory")}}</v-chip>
        </h5>
        <v-menu
            v-model="menu_date"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            v-if="!readonly"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    :value="value"
                    @input="updateValue"
                    prepend-inner-icon="event"
                    readonly
                    outlined
                    v-on="on"
                    clearable
                    :rules="required ? [v => !!v || $t('forms.field.validation.required')] : []"
                ></v-text-field>
            </template>
            <v-date-picker
                :value="value"
                :first-day-of-week="1"
                @input="updateValue"
                show-adjacent-months
                no-title
            ></v-date-picker>
        </v-menu>
        <v-text-field
            :value="value"
            readonly
            v-else
            :disabled="true"
        ></v-text-field>
    </v-col>
</template>

<script>

export default {
    props:{
        value: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        menu_date: false,
    }),
    computed: {
        assigned_label() {
            return this.label ? this.label : this.$t('form.date_start');
        }
    },
    methods: {
        updateValue(newValue) {
            console.log("emitting new value");
            this.menu_date = false;
            this.$emit('input', newValue);
        }
    }
}
</script>